import { TranslationObject } from '../../i18n/translation';

const namespace = 'notification';

const translations: TranslationObject = {
  successTitle: {
    id: `${namespace}.successTitle`,
    nb: 'Suksess',
    en: 'Success',
  },
  errorTitle: {
    id: `${namespace}.errorTitle`,
    nb: 'Feil',
    en: 'Error',
  },
  warningTitle: {
    id: `${namespace}.warningTitle`,
    nb: 'Advarsel:',
    en: 'Warning:',
  },
  removeAllTitle: {
    id: `${namespace}.removeAll`,
    nb: 'Fjern alle varlser',
    en: 'Remove all notifications',
  },
};

export default translations;
